module.exports = __webpack_public_path__ + "img/icon-attivita-commerciali.5005f8b9.svg";